// // src/components/dashboard/FiltersBar/QuickFilters.jsx

// src/components/dashboard/FiltersBar/QuickFilters.jsx
import React from 'react';
import { ToggleButton, ToggleButtonGroup, Box } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { setQuickFilter } from '../../../store/slices/dashboardSlice';

// Values must match the slice / API exactly
const QUICK_FILTERS = [
  { value: 'today',    label: 'Today' },
  { value: 'weekly',   label: 'Weekly' },
  { value: 'monthly',  label: 'Monthly' },
  { value: 'yearly',   label: 'Yearly' },
  { value: 'all_time', label: 'All Time' },
];

const QuickFilters = () => {
  const dispatch     = useDispatch();
  const { quickFilter } = useSelector((state) => state.dashboard.filters);

  const handleChange = (_event, newFilter) => {
    // Keep an explicit period selected. Custom dates can still be enabled
    // from the date-range control by clearing its quick-filter chip.
    if (newFilter) dispatch(setQuickFilter(newFilter));
  };

  return (
    <Box>
      <ToggleButtonGroup
        value={quickFilter}
        exclusive
        onChange={handleChange}
        size="small"
        sx={{
          '& .MuiToggleButton-root': {
            px: 2,
            py: 1,
            minHeight: 44,
            borderColor: 'divider',
            fontWeight: 600,
            fontSize: '0.875rem',
            textTransform: 'none',
            '&.Mui-selected': {
              bgcolor: 'primary.main',
              color: 'primary.contrastText',
              '&:hover': { bgcolor: 'primary.dark' },
            },
            '&:hover': { bgcolor: 'action.hover' },
          },
        }}
        aria-label="quick filters"
      >
        {QUICK_FILTERS.map(({ value, label }) => (
          <ToggleButton key={value} value={value}>
            {label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Box>
  );
};

export default QuickFilters;

